import { Box, useTheme } from '@mui/material';
import ArrowRight from '../../ui/icons/ArrowRight';
import {useCustomTheme} from "../../store/theme-context";

type Props = {
	onClick?: any;
	currentPage?: any;
	setCurrentPage?: any;
	bgcolor?: any;
	color?: any;
	sx?: any;
};

const NextPageArrow = ({ onClick, currentPage, setCurrentPage, bgcolor, color, sx }: Props) => {
	const { palette, breakpoints } = useTheme();
	const { isHighContrast } = useCustomTheme();

	const handleClick = onClick
		? () => {
				onClick();
		  }
		: () => {
				setCurrentPage(currentPage + 1);
		  };

	return (
		<Box
			sx={{
				width: '140px',
				height: '80px',
				borderRadius: '100px 0 0 100px',
				bgcolor: `${bgcolor ? bgcolor : 'rgba(255,255,255,0.6)'}`,
				cursor: 'pointer',
				'& * path': {
					fill: color && color,
				},
				[breakpoints.down('sm')]: {
					width: '92px',
					height: '62px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				},
				...sx,
			}}
			onClick={handleClick}
		>
			<ArrowRight color={isHighContrast ? palette.primary.light : undefined} />
		</Box>
	);
};

export default NextPageArrow;
